// keyboardHandler.js
let dotNetReference = null;

export function registerKeyboardEvents(dotNetRef) {
    dotNetReference = dotNetRef;

    // Add event listener
    document.addEventListener('keydown', handleKeyDown);
    console.log('Keyboard events registered');
}

export function unregisterKeyboardEvents() {
    // Remove event listener
    document.removeEventListener('keydown', handleKeyDown);
    dotNetReference = null;
    console.log('Keyboard events unregistered');
}

function handleKeyDown(event) {
    // Check if Escape key was pressed
    if (event.key === 'Escape' || event.keyCode === 27) {
        // Call the .NET method
        if (dotNetReference) {
            console.log('Escape key pressed, invoking .NET method');
            dotNetReference.invokeMethodAsync('HandleEscapeKey');
        }
    }
}